'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _PublishPropertyOutlineNavigation = require('./PublishPropertyOutlineNavigation.scss');var styles = _interopRequireWildcard(_PublishPropertyOutlineNavigation);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var PublishPropertyOutlineNavigation = function PublishPropertyOutlineNavigation(properties) {var _cx;var
  navigationItems = properties.navigationItems,onSetActive = properties.onSetActive,onSetInactive = properties.onSetInactive,activeStepId = properties.activeStepId;

  var renderNavItem = function renderNavItem(data) {
    var setInactive = function setInactive() {
      if (data.id === 'advertisement') {
        onSetInactive();
      }
    };

    return (
      _react2.default.createElement(_reactScroll.Link, {
          key: data.id,
          activeClass: styles.activeOutlineItem,
          to: data.id,
          spy: true,
          smooth: true,
          isDynamic: true,
          duration: 500,
          offset: -150,
          onSetActive: onSetActive,
          onSetInactive: setInactive },

        data.name));


  };

  var items = navigationItems.map(renderNavItem);

  return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.outlineNavigation, (_cx = {}, _cx[styles.inactive] = !activeStepId, _cx)) },
      items));


}; // Styles
exports.default =
PublishPropertyOutlineNavigation;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishPropertyOutlineNavigation/PublishPropertyOutlineNavigation.js
// module id = 2867
// module chunks = 0